import { render, staticRenderFns } from "./prize-draw.vue?vue&type=template&id=588ca312&scoped=true&"
import script from "./prize-draw.vue?vue&type=script&lang=js&"
export * from "./prize-draw.vue?vue&type=script&lang=js&"
import style0 from "./prize-draw.vue?vue&type=style&index=0&id=588ca312&lang=scss&scoped=true&"
import style1 from "./prize-draw.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588ca312",
  null
  
)

export default component.exports